$('.cvsToggle').on('click', function () {
    var $btn = $(this).siblings('.cvsBtn');

    if ($btn.is(':visible')) {
        $btn.stop(true, true).slideUp(250);
    } else {
        $btn
            .css('display', 'flex')
            .hide()
            .stop(true, true)
            .slideDown(250);
    }
});